import { AuthContextProps } from 'react-oidc-context';
import { httpBff } from '../../http-common';
import FlightReportStatus from '../../model/enum/FlightReportStatus';
import { IFlightReport } from '../../model/IFlightReport';

const getClaims = async () => {
  const data = await httpBff.get('/bff/user');

  return data;
};

const parseToken = (token: string) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

const hasResourceRole = (resource: string, role: string, token: string): boolean => {
  const tokenObj = parseToken(token);
  const resourceAccess = tokenObj.resource_access;
  if (!resourceAccess) return false;
  const roles = resourceAccess[resource || '']?.roles || [];

  return roles.indexOf(role) !== -1;
};

const dispatcherAndDispatcherSupervisor = (auth: AuthContextProps, flightReport: IFlightReport): boolean => {
  if (
    flightReport.status !== FlightReportStatus.signedOff &&
    flightReport.status !== FlightReportStatus.processed &&
    flightReport.status !== FlightReportStatus.approved &&
    hasResourceRole('FlightReports', 'p_Aviat_FlightRpt_W', auth.user?.access_token as string) &&
    hasResourceRole('FlightReports', 'Avi_FlightRptDisps_W', auth.user?.access_token as string)
  ) {
    return true;
  } else {
    return false;
  }
};

const aircraftAccounts = (auth: AuthContextProps): boolean => {
  if (hasResourceRole('FlightReports', 'p_Aviat_FlightRptAppRet_E', auth.user?.access_token as string)) {
    return true;
  } else {
    return false;
  }
};

const validateRolesAndPermission = (auth: AuthContextProps, flightReport: IFlightReport): boolean => {
  if (aircraftAccounts(auth)) {
    return true;
  } else if (dispatcherAndDispatcherSupervisor(auth, flightReport)) {
    return true;
  } else {
    return false;
  }
};

export const AuthenticationService = {
  getClaims,
  parseToken,
  hasResourceRole,
  dispatcherAndDispatcherSupervisor,
  aircraftAccounts,
  validateRolesAndPermission,
};
